import { useQuery } from '@apollo/client/react';
import { MainView } from '@repo/ui/Views';
import SettingsTabNav from '../components/SettingsTabNav';
import ContactDetailsForm from '../components/ContactDetailsForm';

import ME_Q from '@/gql/me.gql';

const SettingsProfile = () => {
  const { data, refetch } = useQuery(ME_Q);

  return (
    <MainView title="Settings">
      <SettingsTabNav />
      {data?.user ? (
        <>
          <ContactDetailsForm
            userId={data.user.id}
            email={data.user.email}
            first_name={data.user.first_name}
            last_name={data.user.last_name}
            refetch={refetch}
          />
        </>
      ) : null}
    </MainView>
  );
};

export default SettingsProfile;
